import React from "react";
import Lottie from "lottie-react";
import { styled } from "@acko-tech/building-blocks.ui.common";
import default_car_annimation from "@public/lottie/default_car_annimation.json";

const amimation = {
  default_car_annimation: default_car_annimation
};

const StyledLottieContainer = styled.div`
  ${(props) => props.styles}
  @media(max-width: 768px) {
    ${(props) => props.mStyles}
  }
`;

const LottieWidget = (props: any) => {
  const { animationKey, is_visible, styles, mStyles } = props;
  if (!is_visible) return null;
  return (
    <StyledLottieContainer styles={styles} mStyles={mStyles}>
      <Lottie animationData={amimation[animationKey]} loop={true} />
    </StyledLottieContainer>
  );
};

export default LottieWidget;

